import { Home, Wrench, Zap, Wind, ArrowLeftRight, BookOpen, ClipboardList, Settings, HardHat, Heart, PenTool } from "lucide-react";
import { useLocation, useNavigate } from "react-router-dom";

const navItems = [
  { path: "/", label: "Home", icon: Home },
  { path: "/pipe", label: "Pipe", icon: Wrench },
  { path: "/electrical", label: "Electrical", icon: Zap },
  { path: "/ductwork", label: "Ductwork", icon: Wind },
  { path: "/structural", label: "Structural", icon: HardHat },
  { path: "/sketch", label: "Sketch", icon: PenTool },
  { path: "/joblog", label: "Job Log", icon: ClipboardList },
  { path: "/settings", label: "Settings", icon: Settings },
  { path: "/support", label: "Support", icon: Heart },
];

const TopNav = () => {
  const location = useLocation();
  const navigate = useNavigate();

  return (
    <header className="hidden md:block fixed top-0 left-0 right-0 bg-card border-b border-border z-50" role="banner">
      <nav className="max-w-7xl mx-auto flex items-center h-12 px-4 gap-1" aria-label="Main navigation">
        {navItems.map((item) => {
          const isActive = location.pathname === item.path;
          return (
            <button
              key={item.path}
              onClick={() => navigate(item.path)}
              className={`flex items-center gap-1.5 px-3 py-1.5 rounded-md text-sm font-medium transition-colors ${
                isActive
                  ? "bg-primary/10 text-primary"
                  : "text-muted-foreground hover:bg-secondary hover:text-foreground"
              }`}
              aria-current={isActive ? "page" : undefined}
            >
              <item.icon className="w-4 h-4" />
              <span>{item.label}</span>
            </button>
          );
        })}
        </nav>
      </header>
  );
};

export default TopNav;
